//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchManageList, fetchUpdate, fetchDelete, fetchRelease } from "@/api/PMS/customerService/lostAndFound/queryList";
import waves from "@/directive/waves"; // 水波纹指令

import listAdd from "./add";
import register from "./register";
import situation from "./situation";
export default {
  name: "ComplexTable",
  components: {
    listAdd: listAdd,
    register: register,
    situation: situation
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      receiverObjectType: "",
      id: -1,
      dates: [],
      pickUpDates: [],
      isDetail: false,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogRegisterVisible: false,
      dialogSituationVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      // if (reload) {
      this.getList(); // }

      if (reload !== 3) {
        this.dialogFormVisible = false;
        this.dialogRegisterVisible = false;
        this.dialogSituationVisible = false;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.publishDateStart = this.dates[0];
        this.listQuery.publishDateEnd = this.dates[1];
      } else {
        this.listQuery.publishDateStart = "";
        this.listQuery.publishDateEnd = "";
      }

      if (this.pickUpDates !== null && this.pickUpDates.length > 0) {
        this.listQuery.pickUpDateStart = this.pickUpDates[0];
        this.listQuery.pickUpDateEnd = this.pickUpDates[1];
      } else {
        this.listQuery.pickUpDateStart = "";
        this.listQuery.pickUpDateEnd = "";
      }

      fetchManageList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.id = -1;
      this.title = "创建";
      this.isDetail = false;
      this.dialogFormVisible = true;
    },
    getRelease: function getRelease(id) {
      var _this2 = this;

      this.$confirm("你确定是要发布这条失物招领吗, 是否继续?", "提示").then(function () {
        fetchRelease({
          id: id,
          publishStatus: 1
        }).then(function (res) {
          if (res.data.code === 200) {
            _this2.getList();

            _this2.Alert({
              alertType: "update",
              message: "发布成功"
            });
          }
        });
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(id) {
      this.id = id;
      this.title = "编辑";
      this.isDetail = false;
      this.dialogFormVisible = true;
    },
    delete: function _delete(ids) {
      var _this3 = this;

      if (ids.length > 0) {
        this.$confirm("你确定是要删除本条记录吗, 是否继续?", "提示").then(function (res) {
          fetchDelete(ids).then(function (res) {
            if (res.data.code === 200) {
              _this3.getList();

              _this3.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    // 登记
    handleRegister: function handleRegister(id) {
      this.id = id;
      this.title = "领取情况登记";
      this.dialogRegisterVisible = true;
    },
    // 查询
    handleQuery: function handleQuery(id) {
      this.id = id;
      this.title = "领取情况查询";
      this.dialogSituationVisible = true;
    },
    handleDelete: function handleDelete(id) {
      var ids = [];
      ids.push(id);
      this.delete(ids);
    },
    // 详情
    getDetail: function getDetail(id) {
      this.id = id;
      this.isDetail = true;
      this.title = "详情";
      this.dialogFormVisible = true;
    }
  }
};